import $ from 'jquery';
import NavTrigger from '../snippets/NavTrigger';
import FadePanel from '../snippets/FadePanel';
import layout from '../Layout';

export default class Meganav {
  constructor(el, postMessage, trigger) {
    this.$el = $(el);
    this.$window = $(window);
    this.namespace = `mega-nav-${trigger}`;

    this.trigger = trigger;
    this.postMessage = postMessage;

    this.navTrigger = new NavTrigger({
      el,
      namespace: this.namespace,
      trigger: this.trigger,
      onShow: () => {
        this.update();
        this.postMessage('nav:close-all', {});
        this.postMessage('nav:close-triggers', { source: this.$el });
        this.postMessage('nav:show-overlay', { source: this.$el });
      },
    });

    // Ensure images have the same height
    this.$window.on(`resize.${this.namespace}`, () => this.update());

    // Fade out edges when scrolling horizontally
    this.fadePanel = new FadePanel('[data-meganav="' + trigger + '"] .meganav-menu-panel-contents');
  }

  onSectionUnload() {
    this.$window.off(`.${this.namespace}`);

    this.navTrigger.unload();
    layout.offBreakpointChange(this.layoutHandler);
  }

  onSectionMessage(name, data) {
    if (name === 'nav:close-triggers' && data.source !== this.$el) {
      this.navTrigger.hide();
    }
    if (name === 'nav:show-overlay') {
      this.navTrigger.showOverlay();
    }
  }

  update() {
    this.fadePanel.update();
    this._updateImageHeights();
  }

  /**
   * Set meganav collection image heights to match the tallest.
   *
   * This is purely visual, to make all the collection titles line up nicely.
   */
  _updateImageHeights() {
    const $images = this.$el.find('.meganav-menu-image');
    if (!$images.length) return;

    // Find maximum image height
    let height = 0;
    $images.each((index, el) => {
      const $img = $(el).find('img, svg').first();
      if (!$img.length) return;

      height = Math.max(height, $img[0].clientHeight);
    });

    // Set all images height to maximum
    if (height) {
      $images.each((index, el) => $(el).height(height));
    }
  }

  /**
   * Remove all data attributes from an element.
   *
   * @param {Element} el
   */
  _removeDataAttributes(el) {
    if (!el || !el.attributes) return;

    const attributesToRemove = [];

    for (let i = el.attributes.length - 1; i >= 0; i--) {
      const name = el.attributes[i].name;

      if (name.substring(0, 5) === 'data-') {
        attributesToRemove.push(name);
      }
    }

    attributesToRemove.forEach(name => el.removeAttribute(name));
  }
}
